import { Link, useSearchParams } from "react-router-dom";
import { useFetch } from "../lib/useFetch";
import Meter from "../components/Meter";
import type { Device } from "../lib/types";

export default function Devices() {
  const [params, setParams] = useSearchParams();
  const clientId = params.get("clientId") ?? "";
  const onlineOnly = params.get("online") === "1";

  const qs = new URLSearchParams();
  if (clientId) qs.set("clientId", clientId);
  if (onlineOnly) qs.set("isOnline", "true");
  const devices = useFetch<Device[]>(`/api/devices?${qs.toString()}`);

  function toggleOnline() {
    const next = new URLSearchParams(params);
    if (onlineOnly) next.delete("online");
    else next.set("online", "1");
    setParams(next);
  }

  return (
    <>
      <div className="topbar">
        <h1>Devices</h1>
        <div className="spacer" />
        <button onClick={toggleOnline} className={onlineOnly ? "primary" : ""}>
          {onlineOnly ? "Showing online" : "All devices"}
        </button>
      </div>

      {devices.error && <div className="error">{devices.error}</div>}

      <div className="card">
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Hostname</th>
              <th>User</th>
              <th>Client</th>
              <th>OS</th>
              <th>CPU</th>
              <th>Disk</th>
              <th>AV</th>
              <th>Patches</th>
              <th>Last seen</th>
            </tr>
          </thead>
          <tbody>
            {devices.data?.map((d) => (
              <tr key={d.id}>
                <td>
                  <span
                    className={`pill dot ${d.isOnline ? "ok" : "danger"}`}
                    title={d.isOnline ? "online" : "offline"}
                  />
                </td>
                <td>
                  <Link to={`/devices/${d.id}`}>{d.hostname}</Link>
                </td>
                <td>{d.username}</td>
                <td>{d.client?.name ?? "—"}</td>
                <td className="muted">
                  {d.os ?? "—"} {d.osVersion ?? ""}
                </td>
                <td>{d.cpuPercent.toFixed(0)}%</td>
                <td>
                  <Meter used={d.diskUsedGb} total={d.diskTotalGb} />
                </td>
                <td>
                  <span
                    className={`pill ${
                      d.avStatus === "ok" ? "ok" : "danger"
                    }`}
                  >
                    {d.avStatus}
                  </span>
                </td>
                <td>
                  {d.patchesPending > 0 ? (
                    <span className="pill warn">{d.patchesPending}</span>
                  ) : (
                    "0"
                  )}
                </td>
                <td className="muted">
                  {new Date(d.lastSeen).toLocaleString()}
                </td>
              </tr>
            ))}
            {devices.data?.length === 0 && (
              <tr>
                <td colSpan={10} className="muted">
                  No devices match.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
